import React,{useEffect} from "react";
import { useNavigate } from "react-router-dom";

export default function TestimonialsPage() {
  useEffect(() => {
        window.scrollTo(0, 0); 
      }, []);
  const navigate = useNavigate();

  const testimonials = [

    {
      image: "/assets/Placements.png",
      title: "Placement",
      description: "Since the start of the program total number of connected trainees with relevant job opportunities by assessing their skills and aligning them with the needs of partner companies.",
    },
    {
      image: "/assets/da.webp",
      title: "Dereja Academy Accelerated Program",
      description: "Since 2020,an intensive training program designed to rapidly equip learners with essential skills for career advancement",
      
    },
    {
      image: "/assets/esjrlogo.jpg",
      title: "Employability Skill & Job Readiness",
      description: "Since 2020, this 4 week training program has been equipping individuals with essential soft skills and practical knowledge to thrive in the workplace and advance their careers.",

    },
    {
      image: "/assets/dls.jpg",
      title: "Digital Litracy Skill",
      description: "Since 2024, this training program that teaches essential digital tools and technologies to help participants confidently navigate and succeed in today’s digital workplace.",
      
    },
    {
      image: "/assets/careercompass.png",
      title: "Career Compass",
      description: "Since 2024, Career Compass is a comprehensive program designed to equip fresh graduates with essential skills, guidance, and practical tools to successfully transition from education to the professional world.",
      
    },
    {
      image: "/assets/derejaProfile.webp",
      title: "Dereja Website",
      description: " Since 2020, Dereja’s website offers a variety of resources like job listings, skills training programs, and career guidance, helping job seekers find opportunities and boost employability.",
      
    },
    
  ];

  return (
    <div className="min-h-screen bg-white px-6 py-10">
      <button
        onClick={() => navigate(-1)}
        className="text-[#fa5d15] font-semibold mb-6"
      >
        ← Back
      </button>

      <h2 className="text-3xl font-bold text-[#fa5d15] mb-6">
        Impact Stories
      </h2>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
    {testimonials.map((item, index) => (
  <div
    key={index}
    onClick={() => {
      if (item.title === "Placement") {
        navigate("/placement", { state: { item } });
      } else if (item.title === "Dereja Academy Accelerated Program") {
        navigate("/daap", { state: { item } });
      } else if (item.title === "Career Compass") {
        navigate("/careercompass", { state: { item } });
      } else if (item.title === "Digital Litracy Skill") {
        navigate("/dls", { state: { item } });
      } else if (item.title === "Employability Skill & Job Readiness") {
        navigate("/esjr", { state: { item } });
      } 
      else if (item.title === "Dereja Website") {
        navigate("/website",{ state: { item } } );
      } else {
        window.open(item.pdfLink, "_blank");
      }
    }}

            
            className="cursor-pointer bg-gray-100 rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300"
          >
            <img
              src={item.image}
              alt={item.title}
              className="w-full h-48 object-contain"
            />
            <div className="p-4">
              <h3 className="text-lg font-bold text-gray-800">{item.title}</h3>
              <p className="text-sm text-gray-600 mt-2">{item.description}</p>
              <p className="mt-2 text-sm text-[#fa5d15] font-medium">
                View Dashbaord →
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
